import { render, staticRenderFns } from "./CreateChildren.vue?vue&type=template&id=1469d221&"
import script from "./CreateChildren.vue?vue&type=script&lang=js&"
export * from "./CreateChildren.vue?vue&type=script&lang=js&"
import style0 from "./CreateChildren.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports